import { atom } from 'recoil'
import accountManager from '../shared/account-manager'

const new_alarm_atom = atom<number>({
  key: '@global/new-alarm',
  default: accountManager.getAlarmNotReadCount() ?? 0,
})

export default new_alarm_atom
